export default {
    'ERROR-ADD-TAG-TO-USER': {
        'TAG-NOT-FOUND-OR-NOT-CREATED': {
            actionType: 'toast',
            message: {
                fr: "Le tag est introuvable ou n'a pas pu être créé.",
                en: 'Tag not found or could not be created.',
            },
        },
        'USER-NOT-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Utilisateur introuvable.",
                en: 'User not found.',
            },
        },
    },
    'ERROR-DELETE-TAG-TO-USER': {
        'TAG-NOT-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Le tag est introuvable.",
                en: 'Tag not found.',
            },
        },
        'USER-NOT-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Utilisateur introuvable.",
                en: 'User not found.',
            },
        },
    },
    'ERROR-ADD-TAG-TO-USERS': {
        'USERS-ARRAY-EMPTY': {
            actionType: 'toast',
            message: {
                fr: "Aucun utilisateur sélectionné.",
                en: 'No users selected.',
            },
        },
        'TAG-NOT-FOUND-OR-NOT-CREATED': {
            actionType: 'toast',
            message: {
                fr: "Le tag est introuvable ou n'a pas pu être créé.",
                en: 'Tag not found or could not be created.',
            },
        },
        'MISMATCH-USER-IDS-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Certains utilisateurs n'ont pas été trouvés.",
                en: 'Some users were not found.',
            },
        },
    },
    'ERROR-DELETE-TAG-TO-USERS': {
        'USERS-ARRAY-EMPTY': {
            actionType: 'toast',
            message: {
                fr: "Aucun utilisateur sélectionné.",
                en: 'No users selected.',
            },
        },
        'TAG-NOT-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Le tag est introuvable.",
                en: 'Tag not found.',
            },
        },
        'MISMATCH-USER-IDS-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Certains utilisateurs n'ont pas été trouvés.",
                en: 'Some users were not found.',
            },
        },
    },
};
